import type { NavigateFunction } from 'react-router-dom';
import {
  listenChildFrame,
  listenLLAFrame,
  listenOuterMessages,
  setSessionIdFromParent,
  widgetSessionCommunication,
} from 'utils';

export const usePostMessageListener =
  (navigate: NavigateFunction) =>
  (event: MessageEvent): void => {
    const { data } = event;

    if (!data && typeof data !== 'object') {
      return;
    }

    switch (data.id) {
      case 'redirectLLA':
        listenLLAFrame(event);
        break;

      case 'redirectFromInnerFrame':
        listenChildFrame(event, navigate);
        break;

      case 'getSessionIdFromParentFrame':
        widgetSessionCommunication();
        break;

      case 'setSessionIdToChildFrame':
        setSessionIdFromParent(event);
        break;

      case 'cashier_BackToMethods':
        listenOuterMessages();
        break;

      default:
        break;
    }
  };
